angular.module(NgAppName).directive('crFieldEscape', ['$filter', function($filter) {
	return {
		restrict: 'A', // only activate on element attribute
		require: '?ngModel', // get a hold of NgModelController
		link: function(scope, element, attrs, ngModel) {
			if (!ngModel) return; // do nothing if no ng-model

			// Specify how Model should be updated
			ngModel.$parsers.push(function(viewValue) {
				 // Remove all characters except numbers and letters (commas, periods ect..)
				var newModelValue = ngModel.$viewValue.replace(/[^a-zA-Z0-9]+/, '');

				if (attrs.allUppercase){
					newModelValue = newModelValue.toUpperCase();
				}

				ngModel.$setViewValue(newModelValue);
				ngModel.$render();
				return newModelValue;
			});

			// Specify how Element should be updated
			ngModel.$render = function() {
				var value = ngModel.$viewValue;
				element.val(value);
			};
		}
	};
}]);
